module.exports = __webpack_public_path__ + "static/media/schody15 - schody drewniane zabiegowe nakladane.192dc7e9.jpg";